import * as CL from '@design-system/component-library';
import { dsClass } from '../../common/constants/dsClasses';
import { editMsg, t } from '../../common/i18n';
import { SubscriptionPbxDetails } from '../../generated/api/subscriptionPbxDetails';
import { MobileActiveChain } from './components/MobileActiveChain';
import { MobileCallDetails } from './components/MobileCallDetails';
import { MobileRespondentList } from './components/MobileRespondentList';
import { MobileWorkingHours } from './components/MobileWorkingHours';
import type { ReachabilityWithMobileFormValues } from '../PbxAccordionContent/PbxAccordionUtils';

import '../PbxAccordionContent/PbxAccordionContent.scss';

interface ReachabilityWithMobileViewProps {
  addonAttributes: ReachabilityWithMobileFormValues;
  onEdit: () => void;
}

export const ReachabilityWithMobileView = ({ addonAttributes, onEdit }: ReachabilityWithMobileViewProps) => {
  const showWorkingHours =
    addonAttributes.currentActiveChain === SubscriptionPbxDetails.CurrentActiveChainEnum.CALENDAR;

  const outOfOfficeNumbers = addonAttributes?.offWorkReachabilityChain || [];
  const workingTimeNumbers = addonAttributes.workingHoursReachabilityChain || [];

  return (
    <div>
      <div className="of-pbx-accordion-content">
        <MobileActiveChain addonAttributes={addonAttributes} />
        {showWorkingHours && <MobileWorkingHours addonAttributes={addonAttributes} edit={false} />}
        <MobileRespondentList
          edit={false}
          workingTimeNumbers={workingTimeNumbers}
          outOfOfficeNumbers={outOfOfficeNumbers}
        />
        <MobileCallDetails edit={false} addonAttributes={addonAttributes} />

        <div className={`${dsClass.PADDING_BOTTOM_3} ${dsClass.PADDING_TOP_6} ${dsClass.PADDING_LEFT_0}`}>
          <CL.Button
            color="light"
            onClick={() => {
              onEdit();
            }}
          >
            {t.NVPK(editMsg)}
          </CL.Button>
        </div>
      </div>
    </div>
  );
};
